


































import { Component, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { TYPES, STATUSES } from '@/constants/booking';
import BookingReadCandidateInformation from './Read/BookingReadCandidateInformation.vue';
import BookingReadInformation from './Read/BookingReadInformation.vue';

@Component({
  components: {
    BookingReadCandidateInformation,
    BookingReadInformation,
  },
  computed: {
    ...mapState('Auth', {
      business: 'activeBusiness',
    }),
    ...mapState('Booking', {
      booking: 'booking',
    }),
  },
})
export default class BookingRead extends Vue {
  // Business State
  business!: Model;

  // Booking State
  booking!: Booking;

  // Data
  types = TYPES;
  statuses = STATUSES;

  retryCount = 0;

  timer: NodeJS.Timeout | null = null;

  isSynced = false;

  isMounted = false;

  // Computed
  get bookingCandidates() {
    return this.booking.booking_candidates || [];
  }

  get isAwaitPayment() {
    return this.booking.status === this.statuses.STATUS_AWAIT_PAYMENT.key;
  }

  get isOngoing() {
    return this.booking.status === this.statuses.STATUS_ONGOING.key;
  }

  // Mounted
  mounted() {
    this.init();
  }

  // BeforeDestroy
  beforeDestroy() {
    this.$store.commit('Booking/RESET_STATE');
  }

  // Methods
  async init() {
    // auto reload for maximum 5 times if the booking is not ready
    this.retryCount = 0;
    while (this.retryCount < 5) {
      await this.fetchBooking();
      if (
        [
          this.statuses.STATUS_ONGOING.key,
          this.statuses.STATUS_AWAIT_PAYMENT.key,
          this.statuses.STATUS_COMPLETED.key,
          this.statuses.STATUS_CANCELLED.key,
        ].includes(this.booking.status)
      ) {
        break;
      }
      await this.wait(3000);
      this.retryCount += 1;
    }
    this.timer = null;
    await this.fetchRiskProfile();
    this.isMounted = true;
  }

  fetchBooking() {
    const bookingOid = this.$route.params.bookingOid;
    return this.$store.dispatch('Booking/fetch', bookingOid);
  }

  fetchRiskProfile() {
    return this.$store.dispatch(
      'RiskProfile/fetchFullStructure',
      this.booking.risk_profile.object_id
    );
  }

  wait(ms) {
    return new Promise((resolve) => {
      this.timer = setTimeout(resolve, ms);
    });
  }

  async cancel() {
    await this.$store.dispatch('Booking/cancel');
    this.isMounted = false;
    this.fetchBooking().then(() => (this.isMounted = true));
  }
}
